<h3 class="ss-subtitle">Engagement</h3>
<div class="engagement-container">
  <div class="header-container">
    <object type="image/svg+xml" role="presentation" alt="" class="logo" data="assets/logos/renaissance_nearpod_logo.svg">
    </object>
    <div class="vertical-bar"></div>
    <div class="header-description">
      <div class="header-description-top">Bring your lessons to life</div>
      <div class="header-description-bottom">
        Customize our ready-to-use lessons or
        <a class="header-description-link" (click)="navigateToNearpod('https://nearpod.com/t/L157299315')"
          (keydown.enter)="navigateToNearpod('https://nearpod.com/t/L157299315')"
          aria-label="Build your own (opens in a new tab)"
          tabindex="0">
          <span class="header-description-link-text">build your own</span>
          <span class="glyph glyph-externallink margin-left-xsmall"></span>
        </a>
      </div>
    </div>
  </div>
  <div class="parent-container">
    <ng-container *ngFor="let skill of skills">
      <div class="item-container" *ngIf="skill?.description && skill?.thumbnailUrl">
        <div class="thumbnail-column">
          <img [src]="skill.thumbnailUrl" alt="Skill Thumbnail" class="skill-thumbnail" />
        </div>
        <div class="description-column">
          <p class="description" multiline-ellipsis="5">{{ skill.description }}</p>
          <a class="ren-btn ren-btn--secondary action-button"
            tabindex="0"
            aria-label="View Nearpod resources (opens in a new tab)"
            (click)="navigateToNearpod(skill.url + '/?referrer=ren_next')" (keydown.enter)="navigateToNearpod(skill.url + '/?referrer=ren_next')">
            View {{ skill.lessonType }}
            <span class="glyph glyph-externallink margin-left-xsmall"></span>
          </a>
        </div>
      </div>
    </ng-container>
  </div>
</div>